import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

// on vite build, the assets from the public folder are copied to the dist folder, so there's no "public" folder anymore. On localhost however, we need to use the public folder so that we can access the new translations when we add them without having to re-run the bun dev command.
let loadPath = '/locales/{{lng}}/{{ns}}.json';
if (import.meta.env.MODE === 'development') {
  loadPath = `/public/${loadPath}`;
}

export async function init() {
  const instance = i18n
    .use(Backend)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next);

  if (import.meta.env.MODE !== 'production') {
    const { HMRPlugin } = await import('i18next-hmr/plugin');

    instance.use(new HMRPlugin({ vite: { client: true } }));
  }

  await instance.init({
    lng: 'en',
    fallbackLng: 'en',
    // this makes sure that empty translations will fallback to english. This makes sure that if we deploy code
    // that has not been translated, it will show the english default instead of nothing.
    returnEmptyString: false,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    backend: {
      debug: true,
      loadPath,
    },
  });

  return instance;
}

export function castAsString(record: Record<string, unknown>): string {
  return record as unknown as string;
}

export default i18n;
